/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'@ba/ba-ui-carbon-toolkit',
	'react',
	'prop-types',
	'mobx-react'
], function (Toolkit, React, PropTypes, MobxReact) {
	'use strict';

	const { Container, VSpacer, Accordion } = Toolkit;
	const { Component } = React;

	const ACCORDION_ICON_POSITION = 'right';
	const CONTAINER_VSPACER_SIZE = 2;

	class PropertiesContainer extends Component {
		render() {
			return (
				<Container className='properties--container'>
					{this.props.banner}
					<VSpacer size={CONTAINER_VSPACER_SIZE} />
					<Accordion icon={ACCORDION_ICON_POSITION} >
						{this.props.sections}
					</Accordion>
				</Container>
			);
		}
	}

	PropertiesContainer.propTypes = {
		banner: PropTypes.object,
		sections: PropTypes.arrayOf(PropTypes.object).isRequired
	};

	return MobxReact.observer(PropertiesContainer);
});
